import { render, staticRenderFns } from "./chooseLang.vue?vue&type=template&id=de65c3d6&scoped=true&lang=html&"
import script from "./chooseLang.vue?vue&type=script&lang=js&"
export * from "./chooseLang.vue?vue&type=script&lang=js&"
import style0 from "./chooseLang.vue?vue&type=style&index=0&id=de65c3d6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de65c3d6",
  null
  
)

component.options.__file = "chooseLang.vue"
export default component.exports